import styled from 'styled-components';

export const ShowYourDoctorRow = styled.div`
  margin-top: ${props => props.theme.space['2.0']};
  :after {
    content: '';
    display: table;
    clear: both;
  }
`;
export const ShowYourDoctorColumn = styled.div`
  float: left;
  width: 50%;
`;
